import { RSSImportParams, RSSImportResult } from 'model';
import { BaseApi } from './BaseAPI';

export const ImportApi = BaseApi.injectEndpoints({
	endpoints: builder => ({
		RSSImport: builder.mutation<RSSImportResult, RSSImportParams>({
			query: (body: RSSImportParams) => ({
				url: `import/rss`,
				method: 'POST',
				body
			})
		})
	})
});

export const { useRSSImportMutation } = ImportApi;
